import * as React from "react"
import {useEffect, useState} from "react"
import {H1Text, H5Text} from "../../../styles/AvantTypography"
import {theme} from "../../../styles/MuiThemes"
import {BreadcrumbHeader} from "../../reports/common/components/Breadcrumbs"
import {Grid} from "@material-ui/core"
import {LevelKeyContent} from "../../reports/common/components/level-key/LevelKeyContent"
import {FilterAndPrintOptions} from "../../reports/common/components/FilterAndPrintOptions"
import {BlueReportType} from "../../reports/common/models/BlueReportType"
import {AvantDateRange} from "../../../util/TimeUtil"
import {ReportSubPaths} from "../../reports/ReportSubPaths"
import {ReportUtils} from "../../reports/ReportUtils"
import LanguageUtils from "../../../util/LanguageUtils"
import {getStampReportSearchQuery, ReportProps} from "../ReportData"
import {ReportGraphFilters} from "../../reports/common/models/ReportGraphFilters"
// import {observer} from "mobx-react-lite"

const StampReportHeader = (props: ReportProps) => {
    const {filters, groupInfo, printOptions} = props
    const {productId} = filters

    const language = LanguageUtils.removeTilde(groupInfo!.language)
    const [query, setQuery] = useState<ReportGraphFilters>()

    useEffect(() => {
        setQuery(getStampReportSearchQuery(filters))
    }, [])

    return (
        <div style={{marginBottom: theme.spacing(4), width: "100%"}}>
            {printOptions == null && <BreadcrumbHeader groupInfo={groupInfo} filters={filters}/>}
            <Grid container={true} spacing={1}>
                <Grid item={true} xs={6}>
                    {groupInfo && (
                        <>
                            <H5Text style={{marginBottom: 4}}>
                                {language}
                            </H5Text>
                            <H1Text>
                                {groupInfo.name}
                            </H1Text>
                        </>
                    )}
                </Grid>
                <Grid item={true} xs={6}>
                    <Grid container={true} alignContent={"flex-end"} spacing={1}>

                        {printOptions != null ? (
                            <LevelKeyContent/>) : (
                            <Grid item={true} xs={12}>
                                <FilterAndPrintOptions
                                    reportType={BlueReportType.CLASS}
                                    filters={filters}
                                    query={query!!}
                                    createLink={
                                        (range: AvantDateRange, selectedValues: string[]) =>
                                            ReportSubPaths.class(ReportUtils.rangeAndValuesToFilters(productId, groupInfo!!.id, range, selectedValues))
                                    }
                                />
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default StampReportHeader
